import { PERSONAL_PAGE_SUBTYPES_BY_FAMILY, PERSONAL_PAGE_SUBTYPE_VALUES } from './constants';
import type { PersonalPageFamily, PersonalPageSubtype } from './types';

export function getFamilyForSubtype(subtype?: PersonalPageSubtype | undefined): PersonalPageFamily | undefined {
  if (!subtype) {
    return undefined;
  }
  for (const [family, subtypes] of Object.entries(PERSONAL_PAGE_SUBTYPES_BY_FAMILY)) {
    if (subtypes.includes(subtype)) {
      return family as PersonalPageFamily;
    }
  }
  throw new Error(`Unknown subtype: ${subtype}`);
}

export function isPersonalPageSubtype(value?: string): value is PersonalPageSubtype {
  return Boolean(value && (PERSONAL_PAGE_SUBTYPE_VALUES as readonly string[]).includes(value));
}
